<template>
  <div v-bind:id="id" class="modal">
    <div class="modal-content">
      <span class="modal-close" v-on:click="closeModal({ 'id': id })">&times;</span>
      <div class="modal-header">
        <h3>
          <slot name="header"></slot>
        </h3>
      </div>
      <div class="modal-body">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ModalBox',
  props: ['id'],
  created: function () {
    if (document.querySelector('.modal-backdrop') == null) {
      var backdrop = document.createElement('div')
      backdrop.classList.add('modal-backdrop')
      document.body.appendChild(backdrop)
    }
  },
  methods: {
    ...mapActions({
      closeModal: 'modal/closeModal'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/utils/modalBox.vue